/* eslint-disable */
"use strict";

import {ODUtil} from "./../../components/util.js";
import ODOffcanvas from "./../../components/offcanvas.js";
import ODToggle from "./../../components/toggle.js";

var ODModulesDropdownToggle = function () {
    // Private properties
    var _body;
    var _element;
    var _toggleObject;

    // Initialize
    var _init = function() {
        _toggleObject = new ODToggle(_element, _body, {
            targetState: 'modules-dropdown-expanded',
            toggleState: ''
        });
    }

    // Public methods
    return {
        init: function(id) {
            _element = ODUtil.getById(id);
            _body = ODUtil.getBody();

            if (!_element) {
                return;
            }

            // hide modules when clicked anywhere on page
            window.onclick = function(event) {
                if (!_element.contains(event.target) && ODUtil.hasClass(_body, 'modules-dropdown-expanded')) {
                    _toggleObject.toggleOff();
                }
            }

            // Initialize
            _init();
        },

        getElement: function() {
            return _element;
        },

        getToggle: function() {
            return _toggleObject;
        },

        onToggle: function(handler) {
            if (typeof _toggleObject.element !== 'undefined') {
                _toggleObject.on('toggle', handler);
            }
        }
    };
}();

export default ODModulesDropdownToggle;
